export const mapSrollToSection = (hash) => {
    const sectionIds = new Set(['about', 'installation', 'cost']);

    if(sectionIds.has(hash)) {
        const section = document.getElementById(hash);
        if(section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }
}